import cmge from "../../assets/images/Example/cmge.png";
import leiting from "../../assets/images/Example/leiting.png";
import eyewind from "../../assets/images/Example/eyewind.png";
import minijoy from "../../assets/images/Example/minijoy.png";
import sagi from "../../assets/images/Example/sagi.png";
import forever9Games from "../../assets/images/Example/forever9Games.png";
import forever9GamesEn from "../../assets/images/Example/forever9Games_en.png";
import nativex from "../../assets/images/Example/nativex.png";
import wawa from "../../assets/images/Example/wawa.png";
import tantan from "../../assets/images/Example/tantan.png";
import tiptop from "../../assets/images/Example/tiptop 1.png"
import going from "../../assets/images/Example/going.png"
import gamehaus from "../../assets/images/Example/gamehaus.png"
import alictus from "../../assets/images/Example/alictus.png"
import triwinGames from "../../assets/images/Example/triwinGames.png"
import shotShort from "../../assets/images/Example/shotShort.png"
import okNovel from "../../assets/images/Example/okNovel.png"
import xGameStudio from "../../assets/images/Example/xGameStudio.png"
import reelShort from "../../assets/images/Example/reelShort.png";
import sparksInfo from "../../assets/images/Example/sparksInfo.png"
import stardustTV from "../../assets/images/Example/stardusttv.png"
import leitingImg from "../../assets/images/More/leiting/bgImg.png";
import cmgeImg from "../../assets/images/More/cmge/bgImg.png";
import eyewindImg from "../../assets/images/More/eyewind/bgImg.png";
import minijoyImg from "../../assets/images/More/minijoy/bgImg.png";
import sagiImg from "../../assets/images/More/sagi/bgImg.png";
import forever9GamesImg from "../../assets/images/More/forever9Games/bgImg.jpg";
import forever9GamesImgEn from "../../assets/images/More/forever9Games/bgImg_en.jpg";
import nativexImg from "../../assets/images/More/nativex/bgImg.jpg";
import wawaImg from "../../assets/images/More/wawa/bgImg.png";
import tantanImg from "../../assets/images/More/tantan/bgImg.png"
import TipTopImg from "@/assets/images/More/TipTop/bgImg.png"
import goingImg from "@/assets/images/More/going/bgImg.jpg"
import gamehausImg from "@/assets/images/More/gamehaus/bgImg.jpg"
import alictusImg from "@/assets/images/More/alictus/bgImg.jpg"
import triwinGamesImg from "@/assets/images/More/triwinGames/bgImg.png"
import shotShortImg from "@/assets/images/More/shotShort/bgImg.jpg"
import xGameStudioImg from "@/assets/images/More/xGameStudio/bgImg.jpg"
import reelShortImg from "@/assets/images/More/reelShort/bgImg.jpg"
import okNovelBg from "@/assets/images/More/okNovel/bgImg.jpg"
import sparksInfoBg from "@/assets/images/More/sparksInfo/bgImg.jpg"
import stardustTVBg from "@/assets/images/More/stardustTV/bgImg.jpg"
import stardustTVBgEn from "@/assets/images/More/stardustTV/bgImg_en.jpg"
import i18n from "../../i18n";
const { t } = i18n
const isEn = i18n.language === 'en'

function getBannerAlt(name) {
  return name + 'banner'
}

const brandList = [
  {
    id: 22,
    name: "example.brand.item22.name",
    logo: stardustTV,
    logoText: "StardustTV",
    link: "",
    img: isEn ? stardustTVBgEn : stardustTVBg,
    value: t('example.brand.item22.text'),
    altText: t('example.brand.item22.altText'),
    bannerAlt: getBannerAlt(t('example.brand.item22.altText'))
  },
  {
    id: 21,
    name: "example.brand.item21.name",
    logo: sparksInfo,
    link: "",
    img: sparksInfoBg,
    value: t('example.brand.item21.text'),
    altText: t('example.brand.item21.altText'),
    bannerAlt: getBannerAlt(t('example.brand.item21.altText'))
  },
  {
    id: 18,
    name: "example.brand.item18.name",
    logo: okNovel,
    link: "",
    img: okNovelBg,
    value: t('example.brand.item18.text'),
    altText: t('example.brand.item18.altText'),
    bannerAlt: getBannerAlt(t('example.brand.item18.altText'))
  },
  {
    id: 17,
    name: "example.brand.item17.name",
    logo: reelShort,
    link: "",
    img: reelShortImg,
    value: t(`example.brand.item17.text`),
    altText: t(`example.brand.item17.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item17.altText`))
  },
  {
    id: 11,
    name: "example.brand.item11.name",
    logo: going,
    link: "",
    img: goingImg,
    value: t(`example.brand.item11.text`),
    altText: t(`example.brand.item11.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item11.altText`))
  },
  {
    id: 12,
    name: "example.brand.item12.name",
    logo: gamehaus,
    link: "",
    img: gamehausImg,
    value: t(`example.brand.item12.text`),
    altText: t(`example.brand.item12.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item12.altText`))
  },
  {
    id: 13,
    name: "example.brand.item13.name",
    logo: alictus,
    link: "",
    img: alictusImg,
    value: t(`example.brand.item13.text`),
    altText: t(`example.brand.item13.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item13.altText`))
  },
  {
    id: 10,
    name: "example.brand.item10.name",
    logo: tiptop,
    img: TipTopImg,
    link: "",
    value: t(`example.brand.item10.text`),
    altText: t(`example.brand.item10.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item10.altText`))
  },
  {
    id: 2,
    name: "example.brand.item2.name",
    logo: cmge,
    link: "",
    img: cmgeImg,
    value: t(`example.brand.item2.text`),
    altText: t(`example.brand.item2.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item2.altText`))
  },
  {
    id: 1,
    name: "example.brand.item1.name",
    logo: leiting,
    link: "",
    img: leitingImg,
    value: t(`example.brand.item1.text`),
    altText: t(`example.brand.item1.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item1.altText`))
  },
  {
    id: 4,
    name: "example.brand.item4.name",
    logo: minijoy,
    link: "",
    img: minijoyImg,
    value: t(`example.brand.item4.text`),
    backColor: "#254FFF",
    altText: t(`example.brand.item4.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item4.altText`))
  },
  {
    id: 3,
    name: "example.brand.item3.name",
    logo: eyewind,
    link: "",
    img: eyewindImg,
    value: t(`example.brand.item3.text`),
    altText: t(`example.brand.item3.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item3.altText`))
  },
  {
    id: 5,
    name: "example.brand.item5.name",
    logo: wawa,
    link: "",
    img: wawaImg,
    value: t(`example.brand.item5.text`),
    altText: t(`example.brand.item5.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item5.altText`))
  },
  {
    id: 14,
    name: "example.brand.item14.name",
    logo: triwinGames,
    link: "",
    img: triwinGamesImg,
    value: t(`example.brand.item14.text`),
    altText: t(`example.brand.item14.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item14.altText`))
  },
  {
    id: 15,
    name: "example.brand.item15.name",
    logo: shotShort,
    link: "",
    img: shotShortImg,
    value: t(`example.brand.item15.text`),
    altText: t(`example.brand.item15.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item15.altText`))
  },
  {
    id: 16,
    name: "example.brand.item16.name",
    logo: xGameStudio,
    link: "",
    img: xGameStudioImg,
    value: t(`example.brand.item16.text`),
    altText: t(`example.brand.item16.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item16.altText`))
  },
  {
    id: 8,
    name: "example.brand.item8.name",
    logo: tantan,
    link: "",
    img: tantanImg,
    value: t(`example.brand.item8.text`),
    altText: t(`example.brand.item8.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item8.altText`))
  },
  {
    id: 6,
    name: "example.brand.item6.name",
    logo: sagi,
    link: "",
    img: sagiImg,
    value: t(`example.brand.item6.text`),
    altText: t(`example.brand.item6.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item6.altText`))
  },
  {
    id: 19,
    name: "example.brand.item19.name",
    logo: isEn ? forever9GamesEn : forever9Games,
    link: "",
    img: isEn ? forever9GamesImgEn : forever9GamesImg,
    value: t(`example.brand.item19.text`),
    altText: t(`example.brand.item19.altText`),
    bannerAlt: getBannerAlt(t(`example.brand.item19.altText`))
  },
  ...(isEn ? [
    {
      id: 20,
      name: "example.brand.item20.name",
      logo: nativex,
      link: "",
      img: nativexImg,
      value: t(`example.brand.item20.text`),
      altText: t(`example.brand.item20.altText`),
      bannerAlt: getBannerAlt(t(`example.brand.item20.altText`))
    }
  ] : [])

];

console.log(brandList)

export { brandList };
